import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import ChainDetailsSummaryCard from './ChainDetailsSummaryCard';
import ChainDetailsWorkshopsCard from './ChainDetailsWorkshopsCard';
import ChainUsersOverviewCard from './ChainUsersOverviewCard';

const ChainDetailsPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const chainId = Number(id);
  const navigate = useNavigate();

  if (isNaN(chainId)) {
    navigate('/404', { replace: true });
    return null;
  }
  return (
    <ContentLayout>
      <PageMetatags title={t('pages:chains.meta.title')} />
      <ChainDetailsSummaryCard chainId={chainId} />
      <ChainUsersOverviewCard chainId={chainId} />
      <ChainDetailsWorkshopsCard chainId={chainId} />
    </ContentLayout>
  );
};

export default ChainDetailsPage;
